var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCirclesTopRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 65
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".circles-top-right_svg__cls-1{fill:#5f48e9}.circles-top-right_svg__cls-2{fill:#001847}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circles-top-right_svg__Group_16277",
    transform: "translate(-1564 -80)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circles-top-right_svg__Ellipse_370",
    cx: 4,
    cy: 4,
    r: 4,
    className: "circles-top-right_svg__cls-1",
    transform: "translate(1622 80)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circles-top-right_svg__Ellipse_373",
    cx: 4,
    cy: 4,
    r: 4,
    className: "circles-top-right_svg__cls-1",
    transform: "translate(1593 80)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circles-top-right_svg__Ellipse_376",
    cx: 4,
    cy: 4,
    r: 4,
    className: "circles-top-right_svg__cls-1",
    transform: "translate(1612 123)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circles-top-right_svg__Ellipse_375",
    cx: 4,
    cy: 4,
    r: 4,
    className: "circles-top-right_svg__cls-1",
    transform: "translate(1564 81)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circles-top-right_svg__Ellipse_371",
    cx: 4,
    cy: 4,
    r: 4,
    className: "circles-top-right_svg__cls-1",
    transform: "translate(1637 94)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circles-top-right_svg__Ellipse_372",
    cx: 4,
    cy: 4,
    r: 4,
    className: "circles-top-right_svg__cls-1",
    transform: "translate(1608 94)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circles-top-right_svg__Ellipse_377",
    cx: 4,
    cy: 4,
    r: 4,
    className: "circles-top-right_svg__cls-2",
    transform: "translate(1627 137)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circles-top-right_svg__Ellipse_378",
    cx: 4,
    cy: 4,
    r: 4,
    className: "circles-top-right_svg__cls-2",
    transform: "translate(1624 109)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circles-top-right_svg__Ellipse_374",
    cx: 4,
    cy: 4,
    r: 4,
    className: "circles-top-right_svg__cls-2",
    transform: "translate(1579 95)"
  }))));
}

export default SvgCirclesTopRight;